import { GButton } from "./GButton";
import { RelationType } from "./Const";
import { GTextField } from "./GTextField";
import { UIConfig2 } from "./UIConfig";
import { EventDispatcher } from "../events/EventDispatcher";
import { GRoot } from "./GRoot";
import { UIEvent } from "./UIEvent";
import { Loader } from "../net/Loader";
const internalEvent = "click_menu_item";
export class PopupMenu extends EventDispatcher {
    constructor(res, seperatorRes) {
        super();
        this.visibleItemCount = 0;
        this.hideOnClickItem = true;
        this.autoSize = false;
        if (!res)
            res = UIConfig2.popupMenu;
        let prefab = res ? Loader.getRes(res) : null;
        if (!res)
            throw new Error("UIConfig.popupMenu not defined");
        this._seperatorRes = seperatorRes || UIConfig2.popupMenuSeperator;
        this._content = prefab.create();
        this._initWidth = this._content.width;
        this._list = this._content.getChild("list");
        this._list.removeChildrenToPool();
        this._list.addRelation(this._content, RelationType.Width);
        this._list.removeRelation(this._content, RelationType.Height);
        this._content.addRelation(this._list, RelationType.Height);
        this._list.on(UIEvent.ClickItem, this, this._clickItem);
    }
    destroy() {
        this._content.destroy();
    }
    addItem(caption, callback, target) {
        let item = this.createItem(caption, callback, target);
        this._list.addChild(item);
        return item;
    }
    addItemAt(caption, index, callback, target) {
        let item = this.createItem(caption, callback, target);
        this._list.addChildAt(item, index);
        return item;
    }
    createItem(caption, callback, target) {
        let item = this._list.getFromPool();
        item.text = caption;
        item.grayed = false;
        let c = item.getController("checked");
        if (c)
            c.selectedIndex = 0;
        item.offAll(internalEvent);
        if (callback)
            item.on(internalEvent, target, callback, [item]);
        return item;
    }
    addSeperator(index) {
        if (index == undefined || index == -1)
            this._list.addItemFromPool(this._seperatorRes);
        else {
            let item = this._list.getFromPool(this._seperatorRes);
            this._list.addChildAt(item, index);
        }
    }
    getItemName(index) {
        let item = this._list.getChildAt(index);
        return item.name;
    }
    setItemText(name, caption) {
        let item = this._list.getChild(name);
        item.text = caption;
    }
    setItemVisible(name, visible) {
        let item = this._list.getChild(name);
        item.visible = visible;
    }
    setItemGrayed(name, grayed) {
        let item = this._list.getChild(name);
        item.grayed = grayed;
    }
    setItemCheckable(name, checkable) {
        let item = this._list.getChild(name);
        let c = item.getController("checked");
        if (c) {
            if (checkable) {
                if (c.selectedIndex == 0)
                    c.selectedIndex = 1;
            }
            else
                c.selectedIndex = 0;
        }
    }
    setItemChecked(name, checked) {
        let item = this._list.getChild(name);
        let c = item.getController("checked");
        if (c)
            c.selectedIndex = checked ? 2 : 1;
    }
    isItemChecked(name) {
        let item = this._list.getChild(name);
        let c = item.getController("checked");
        if (c)
            return c.selectedIndex == 2;
        else
            return false;
    }
    removeItem(name) {
        let item = this._list.getChild(name);
        if (item) {
            let index = this._list.getChildIndex(item);
            this._list.removeChildToPoolAt(index);
            return true;
        }
        else
            return false;
    }
    clearItems() {
        this._list.removeChildrenToPool();
    }
    get itemCount() {
        return this._list.numChildren;
    }
    get contentPane() {
        return this._content;
    }
    get list() {
        return this._list;
    }
    show(target, dir) {
        if (GRoot.inst.popupMgr.isPopupJustClosed(this._content))
            return;
        this.event(UIEvent.Popup);
        if (this.autoSize) {
            this._list.layout.refresh();
            let cnt = this._list.numChildren;
            let maxDelta = -1000;
            for (let i = 0; i < cnt; i++) {
                let obj = this._list.getChildAt(i);
                if (!(obj instanceof GButton))
                    continue;
                let tf = obj.findTextWidget();
                if (tf instanceof GTextField) {
                    let v = tf.textWidth - tf.width;
                    if (v > maxDelta)
                        maxDelta = v;
                }
            }
            if (this._content.width + maxDelta > this._initWidth)
                this._content.width += maxDelta;
            else
                this._content.width = this._initWidth;
        }
        this._list.selection.index = -1;
        this._list.resizeToFit(this.visibleItemCount > 0 ? this.visibleItemCount : Number.POSITIVE_INFINITY, 10);
        GRoot.inst.popupMgr.togglePopup(this._content, target, dir);
    }
    hide() {
        if (this._content.parent)
            GRoot.inst.popupMgr.hidePopup(this._content);
    }
    _clickItem(item) {
        if (!(item instanceof GButton))
            return;
        if (item.grayed) {
            this._list.selection.index = -1;
            return;
        }
        let c = item.getController("checked");
        if (c && c.selectedIndex != 0) {
            if (c.selectedIndex == 1)
                c.selectedIndex = 2;
            else
                c.selectedIndex = 1;
        }
        if (this.hideOnClickItem)
            this.hide();
        item.event(internalEvent, item);
    }
}
